<template>
    <div id="main" ref="cockpit" :class="{ 'no-charts': !showCharts }">
        <div class="page">
            <loader v-if="isLoading"/>
            <!-- Barra Superior -->
			<div class="columns chart-toolbar is-multiline z-index-1">
				<!-- COLLAPSE DO FILTRO -->
				<div class="column">
					<b-collapse class="card" :open="false">
						<div slot="trigger" slot-scope="props" class="card-header is-paddingless">
							<div class="card-header-title">
								<div class="filtro-header">
									<b-icon :icon="props.open ? 'menu-down' : 'menu-right'"></b-icon>
									<span class="is-size-7">{{ $t('filtros') }}</span>
								</div>
							</div>
						</div>
						<div class="card-content">
							<div class="columns is-multiline is-variable is-2">
								<!-- COMBOS TIPO, VENDEDORES E EMPRESA -->
								<div class="column is-full-touch is-full-desktop is-full-widescreen is-two-thirds-fullhd">
									<div class="columns is-variable is-2">
										<div
											class="column"
										>
											<label><span>{{ $t('empresas') }}</span></label>
											<vss-select
												v-model="empresasSelected"
												:options="empresas"
                                                :closeOnSelect="false"
                                                :loading="empresasLoading"
												@search="loadEmpresas"
												no-clearfix
                                                multiple
                                                clearable
                                                searchable
											>
												<template #multiple-selected="{ selected }">
													({{ selected && selected.length > 0 ? selected.length : $t('todos') }})
												</template>
											</vss-select>
										</div>
										<div class="column">
											<label>
												<span>{{ $t('colaboradores') }}</span>
												<b-tooltip
												class="tooltip-label"
												:label="$t('msg-filtros-colaboradores')"
												position="is-right"
												type="is-dark"
												size="is-large"
												multilined
												>
													<b-icon icon="information" size="is-small" />
												</b-tooltip>
											</label>
											<vss-select
												v-model="colaboradoresSelected"
												:options="colaboradores"
                                                :closeOnSelect="false"
												:loading="colaboradoresLoading"
												@search="loadColaboradores"
												no-clearfix
                                                multiple
                                                clearable
                                                searchable
											>
												<template #multiple-selected="{ selected }">
													({{ selected && selected.length > 0 ? selected.length : $t('todos') }})
												</template>
											</vss-select>
										</div>
                                        <div class="column">
                                            <label>
												<span>{{ $t('clientes') }}</span>
											</label>
											<vss-select
												v-model="clientesSelected"
												:options="clientes"
                                                :closeOnSelect="false"
												:loading="clientesLoading"
												@search="loadClientes"
												no-clearfix
                                                multiple
                                                clearable
                                                searchable
											>
												<template #multiple-selected="{ selected }">
													({{ selected && selected.length > 0 ? selected.length : $t('todos') }})
												</template>
											</vss-select>
										</div>
									</div>
								</div>

								<!-- DATAS -->
								<div class="column is-full-touch is-full-desktop is-full-widescreen is-one-third-fullhd">
									<div class="columns is-variable is-2">
										<div class="column">
											<verified-date-picker
												dateType="startDate"
												v-model="dataInicio"
												:endDate="dataFim"
												:title="'data-inicio'"
												position="is-bottom-right"
												:invalid="erroDataInicio"
                                                :tooltipLabel="'informacao-filtro-data-inicial-cockpit'"
                                                tooltipSize="is-medium"
                                                tooltipPosition="is-bottom"
											/>
										</div>
										<div class="column">
											<verified-date-picker
												dateType="endDate"
												v-model="dataFim"
												:startDate="dataInicio"
												:title="'data-fim'"
												position="is-bottom-left"
												:invalid="erroDataFim"
												:addDateYears="5"
                                                :tooltipLabel="'informacao-filtro-data-fim-cockpit'"
                                                tooltipSize="is-medium"
                                                tooltipPosition="is-bottom"
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
					</b-collapse>
				</div>

				<!-- BOTÕES -->
				<div class="column is-narrow">
					<b-button
						class="top-btn"
						type="is-light"
						@click="saveFiltros"
						:disabled="isSavingFilter"
					>
						<span class="has-text-weight-bold is-size-7">
							{{$t('aplicar-filtros')}}
						</span>
					</b-button>

					<b-button
						class="top-btn"
						type="is-light"
						@click="confirmCleanFilters"
						:disabled="isSavingFilter"
					>
						<span class="has-text-weight-bold is-size-7">
							{{$t('limpar-filtros')}}
						</span>
					</b-button>
				</div>
			</div>

            <div class="manage-charts-shortcut">
                <b-modal :active.sync="isChartSelectOpen">
                    <div class="modal-card">
                        <header class="modal-card-head">
                            <p class="title is-marginless is-paddingless">{{ $t('add-graficos-cockpit') }}</p>
                        </header>
                        <section class="modal-card-body" v-if="chartsAvailable && chartsAvailable.length > 0">
                            <div class="columns">
                                <div class="column">
                                    <search-bar :onSearch="debouncedOnSearch" hideTitle />
                                </div>
                            </div>
                            <div class="columns">
                                <div class="categorias column is-one-third is-hidden-mobile">
                                    <div class="columns is-multiline">
                                        <div class="column is-full">
                                            <span class="subtitle">{{ $t('categorias') }}</span>
                                        </div>
                                        <div class="column is-full" v-for="(c, i) in categorias" :key="i">
                                            <a @click="filterCategoria(c.nome)">{{ $t(c.nome) }}</a>
                                            <span class="tag is-pulled-right">{{ c.qtd }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="result-set column">
                                    <div class="columns is-multiline">
                                        <div class="column is-full" v-for="(c, i) in resultSet" :key="i">
                                            <span class="subtitle has-text-justified">{{ $t(c.nome) }}</span>
                                            <p class="has-text-justified" style="font-size: 12px;">
                                                {{ getChartDesc(c) }}
                                            </p>
                                            <button class="delete-btn" v-if="isInCockpit(c)" @click="deleteChart(c)">
                                                {{ $t('del-cockpit') }}
                                            </button>
                                            <button class="add-btn" v-else @click="addChart(c)">
                                                {{ $t('add-cockpit') }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section v-else>
                            <div class="columns">
                                <div class="no-results column">
                                    {{ $t('sem-graficos') }}
                                </div>
                            </div>
                        </section>
                    </div>
                </b-modal>
            </div>
            <div
                class="chart-container"
                ref="PackeryMagic"
                v-if="showCharts"
            >
            <div class="msry-gutter"></div>
            <div class="pkry-sizer"></div>
                <div
                    v-for="(d, i) in dataset"
                    :key="i"
                    class="chart draggable"
                    ref="chartItem"
                    :class="{ 'full-size-chart': d && (d.titulo == 'quantidade-atendimentos-colaboradores'), 'big-number' : d && d.tipo == 'bignumber', speedometer : d && d.tipo == 'speedometer', 'line-chart' : d && d.tipo == 'line' }"
                >
                    <ZoomBarChart
                        :ref="`${d.tipo}-${d.titulo}`"
                        v-if="d && d.tipo == 'bar'"
                        :title="$t(d.titulo)"
                        :datacontent="d"
                        :direction="d.direction"
                    />
                    <BigNumber 
                        :ref="`${d.tipo}-${d.titulo}`"
                        v-if="d && d.tipo == 'bignumber'"
                        :title="$t(d.titulo)" 
                        :datacontent="d"
                        :showPercent="false"
                    />
                    <DonutChart 
                        :ref="`${d.tipo}-${d.titulo}`"
                        v-if="d && d.tipo == 'donut'"
                        :title="$t(d.titulo)" 
                        :datacontent="d"
                    />
                    <LineChart 
                        :ref="`${d.tipo}-${d.titulo}`"
                        v-if="d && d.tipo == 'line'"
                        :title="$t(d.titulo)" 
                        :datacontent="d"
                    />
                    <PieChart 
                        :ref="`${d.tipo}-${d.titulo}`"
                        v-if="d && d.tipo == 'pie'"
                        :title="$t(d.titulo)" 
                        :datacontent="d"
                    />
                    <SpeedometerChart
                        :ref="`${d.tipo}-${d.titulo}`"
                        v-if="d && d.tipo == 'speedometer'"
                        :title="$t(d.titulo)"
                        :datacontent="d"
                    />
                    <StackBarChart
                        :ref="`${d.tipo}-${d.titulo}`"
                        v-if="d && d.tipo == 'stack'"
                        :title="$t(d.titulo)"
                        :datacontent="d.datacontent"
                    />
                </div>
            </div>
            <div class="center" v-else>
                <div class="elipse">
                    <svg class="big-svg-icons">
                        <use :xlink:href="require('@/assets/img/icons/speedometer.svg')+'#layer'"></use>
                    </svg>
                </div>
                <p>{{$t('cockpit-sem-dados')}}</p>
                <button
                    class="button no-data-btn"
                    type="button"
                    @click="startRegistration()"
                >{{$t('cockpit-buttom')}}</button>
            </div>
        </div>
    </div>
</template>

<script>
import HelperCard from "@/components/shared/HelperCard";
import DonutChart from "@/components/shared/chart/DonutChart";
import PieChart from "@/components/shared/chart/PieChart";
import AreaChart from "@/components/shared/chart/AreaChart";
import LineChart from "@/components/shared/chart/LineChart";
import BigNumber from "@/components/shared/chart/BigNumber";
import ZoomBarChart from "@/components/shared/chart/ZoomBarChart";
import StackBarChart from "@/components/shared/chart/StackBarChart";
import SpeedometerChart from "@/components/shared/chart/SpeedometerChart";
import CockpitService from "@/services/CockpitService";
import { Container, Draggable } from "vue-smooth-dnd";
import Draggabilly from 'draggabilly';
import Packery from 'packery';
import FiltroCockpitService from '@/services/FiltroCockpitService'

export default {
    components: {
        HelperCard,
        DonutChart,
        PieChart,
        LineChart,
        AreaChart,
        ZoomBarChart,
        BigNumber,
        SpeedometerChart,
        StackBarChart,
        Container,
        Draggable
    },
    data() {
        return {
            service: null,
            filtroCockpitService: new FiltroCockpitService(this.$http, this.$router),
            items: [],
            dataset: [],
            isLoading: false,
            isChartSelectOpen: false,
            chartsAvailable: [],
            categorias: [],
            searchSet: [],
            resultSet: [],
            searching: false,
            showCharts: false,
            charts: [],
            lastSize: {
                w: 0, h: 0
            },
            draggies: [],
            pckr: null,
            dragOpts: {
                handle: '.chart-title'
            },
            packeryOpts: {
                itemSelector: ".chart",
                percentPosition: true,
                transitionDuration: "0.3s",
                gutter: ".msry-gutter",
                columnWidth: ".pkry-sizer"
            },
            empresasSelected: [],
            empresas: [],
            empresasLoading: false,
            colaboradoresSelected: [],
            colaboradores: [],
            colaboradoresLoading: false,
            clientesSelected: [],
            clientes: [],
            clientesLoading: false,
            dataInicio: null,
            dataFim: null,
            erroDataInicio: null,
            erroDataFim: null,
            isSavingFilter: false,
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess("promotor", "cockpit", "pro-cockpit");
        if ( !this.permissao.read ){
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'promotor-titulo-cockpit' }
            });
        } else {
            this.service = new CockpitService(this.$http, this.$router);

            this.dataFim = new Date();
            this.dataInicio = new Date(this.dataFim.getFullYear(), this.dataFim.getMonth(), 1);
            
            this.carregarCartoes();
            let body = document.getElementsByTagName("body")[0];

            this.lastSize.x = document.body.clientWidth;
            this.lastSize.y = document.body.clientHeight;

            body.onresize = this.debounce(this.resize, 150);

        }
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
    },
    beforeDestroy () {
        document.body.onresize = null;
    },
    methods: {
        resize() {
            let currentSize = {
                x: document.body.clientWidth,
                y: document.body.clientHeight
            }

            if (currentSize.x != this.lastSize.x) {
                this.charts.forEach(c => {
                    if (c && c.tipo != 'bignumber') {
                        this.$refs[`${c.tipo}-${c.titulo}`][0].redrawChart();
                    }
                });
            }

            this.lastSize = currentSize;
        },
        carregarCartoes() {
            const idsEmpresas = this.empresasSelected.map(empresa => empresa.id);
            const idsColaboradores = this.colaboradoresSelected.map(colaborador => colaborador.id);
            const idsClientes = this.clientesSelected.map(cliente => cliente.id);

            this.isLoading = true;
            
            this.$axios.post('/cockpit.json', {
                idsEmpresas,
                idsColaboradores,
                idsClientes,
                dataInicio: this.dataInicio,
                dataFim: this.dataFim
            })
            .then(response => {
                if (response.data.content) {
                    this.showCharts = true;
                    this.charts = response.data.content.charts;
                    this.loadAll();
                }
            });
        },
        loadAll() {
            let list = this.charts;
            let body = document.getElementsByTagName("body")[0];
            this.dataset = [...list];
            this.mapStackChart();
            if (body.offsetWidth > 760 && body.offsetWidth < 861) {
                let line = this.dataset.filter(d => d.tipo == "line")[0];
                let i = this.dataset.indexOf(line);
                if (i > -1) {
                    this.dataset.splice(this.dataset.indexOf(line), 1);
                    this.dataset.push(line);
                }
            }
            this.mountCockpitCharts();
            this.isLoading = false;
        },
        mapStackChart() {
            this.dataset = this.dataset.filter(d => d != null);
            this.dataset.forEach(d => {
                if (d && d.tipo == "stack") {
                    d.datacontent = [];
                    Object.getOwnPropertyNames(d.items).forEach(i => {
                        let dt = {};
                        dt.row = i;
                        if (i != "__ob__") {
                            d.items[i].forEach(v => {
                                dt[v.label] = v.value;
                            });
                            d.datacontent.push(dt);
                        }
                    });
                    d.datacontent.sort((d1, d2) => d1.row.localeCompare(d2.row));
                }
            });
        },
        startRegistration(){
            this.$router.push({
                'name': 'clientes'
            });
        },
        mountCockpitCharts(){
            setTimeout( () => {
                
                let elemPack = this.$refs.PackeryMagic
                this.pckr = new Packery(elemPack, this.packeryOpts );

                this.pckr.getItemElements().forEach( ( itemElem ) => {
                    var draggie = new Draggabilly( itemElem, this.dragOpts );
                    this.pckr.bindDraggabillyEvents( draggie );
                });

            }, 600);
        },
        // Métodos do gerenciamento de gráficos
        filterCategoria(nome) {
            if (this.searching) {
                this.resultSet = this.searchSet.filter(c => {
                    return c.categoria == nome;
                });
            } else {
                this.resultSet = this.chartsAvailable.filter(c => {
                    return c.categoria == nome;
                });
            }
        },
        isInCockpit(c) {
            return this.dataset.find(e => {
                return e.titulo == c.nome;
            });
        },
        getCategories () {
            this.categorias = [];

            this.resultSet.forEach(c => {
                var index = this.categorias.findIndex(e => { return (e.nome == c.categoria) });
                if (index < 0) {
                    this.categorias.push({
                        nome: c.categoria, qtd: 1
                    });
                } else {
                    this.categorias[index].qtd++;
                }
            });
        },
        onSearch(value) {
            var searchValue = value.trim();

            if (searchValue != '') {
                this.searching = true;
                this.resultSet = this.chartsAvailable.filter(c => {
                    return this.$t(c.nome).search(new RegExp(searchValue, 'i')) > -1;
                });
                this.searchSet = this.resultSet;
            } else {
                this.searching = false;
                this.resultSet = this.chartsAvailable;
            }

            this.getCategories();
        },
        deleteChart(c) {
            var index = this.dataset.findIndex(e => {
                return e.titulo == c.nome;
            });
            this.dataset.splice(index, 1);
            this.mountCockpitCharts();
        },
        openModalGraficos () {
            this.resultSet = this.chartsAvailable;
            this.getCategories();
            this.isChartSelectOpen = true;
        },
        getChartDesc(c) {
            if (c.descricao != null || c.descricao != undefined) {
                return (this.$t(c.descricao) ? this.$t(c.descricao) : this.$t('chart-no-desc'));
            } else {
                console.warn("Descrição inexistente para " + c.nome);
                return this.$t('chart-no-desc');
            }
        },
        async loadColaboradores(query = ".*") {
            this.colaboradoresLoading = true;

            try {
                const response = await this.$axios.get('/employees/list/associated.json', {
                    params: {
                        param: query,
                        limit: 1000
                    }
                })

                const colaboradoresMappedToSelect = this.mapColaboradoresToSelect(response.data.content);

                this.colaboradores = colaboradoresMappedToSelect;
            } catch (e) {
                console.error(e);
                this.$root.showMessage('error', 'msg-erro-load');
            }
            finally {
                this.colaboradoresLoading = false;
            }
        },
        mapColaboradoresToSelect(colaboradores) {
            return colaboradores.map(colaborador => ({
                id: colaborador.id,
                label: colaborador.nome
            }))
        },
        async loadClientes(query = ".*") {
            this.clientesLoading = true;

            try {
                const response = await this.$axios.get('/promotor/cliente/getcombo.json', {
                    params: {
                        param: query,
                        situacao: 1
                    }
                })

                const clientesMappedToSelect = this.mapClientesToSelect(response.data.content);

                this.clientes = clientesMappedToSelect;
            } catch (e) {
                console.error(e);
                this.$root.showMessage('error', 'msg-erro-load');
            }
            finally {
                this.clientesLoading = false;
            }
        },
        mapClientesToSelect(clientes) {
            return clientes.map(cliente => ({
                id: cliente.idcliente,
                label: cliente.rsocial
            }))
        },
        async loadEmpresas(query = ".*") {
            this.empresasLoading = true;

            try {
                const response = await this.$axios.get('/getcombo/empresa.json', {
                    params: {
                        param: query,
                        situacao: 3
                    }
                })

                const empresasMappedToSelect = this.mapEmpresasToSelect(response.data.content);

                this.empresas = empresasMappedToSelect;
            } catch (e) {
                console.error(e);
                this.$root.showMessage('error', 'msg-erro-load');
            }
            finally {
                this.empresasLoading = false;
            }
        },
        mapEmpresasToSelect(empresas) {
            return empresas.map(empresa => ({
                id: empresa.idempresa,
                label: empresa.rsocial
            }))
        },
        saveFiltros() {
            this.carregarCartoes();
        },
        confirmCleanFilters() {
            this.$root.confirm({
                message: this.$t('msg-confirm-limpar-filtros'),
                onConfirm: this.clearFilters,
                onCancel: () => {}
            });
        },
        clearFilters() {
            this.empresasSelected = [];
            this.colaboradoresSelected = [];
            this.clientesSelected = [];
            this.dataFim = new Date();
            this.dataInicio = new Date(this.dataFim.getFullYear(), this.dataFim.getMonth(), 1);
            
            this.saveFiltros();
        }
    },
};
</script>

<style lang="scss" scoped>
.chart-toolbar .column .card{
	overflow: initial;
}
.chart-toolbar {
	position: sticky;
	top: 0;
	background: $bg-color; /* Precisa pq se não os elementos vão passar por cima do sticky por ser transparente. */
	/* Se for aumentar esse z-index, verificar dois possíveis pontos de falha
		- O modal do botão "Gerenciar gráficos"
		- O modal do botão de usuário no canto superior direito que ativa quando no modo mobile
	*/

	.top-btn {
		height: 36px;
		margin-right: 10px !important;
	}

	.card {
		color: $darker-gray-color;

		.card-header-title {
			color: $darker-gray-color;
			justify-content: space-between;
			padding: 0.3rem;
		}

		.card-content {
			padding: 0.9rem;

			.card-content-top {
				padding-top: 0.25rem;
				padding-bottom: 0.25rem;
			}
		}
	}

	.filtro-header {
		display: flex;
		align-items: center;
	}

	.filtros-extras {
		font-size: 12px;
	}
}

.z-index-1 {
    z-index: 1;
}

#main {
    padding: 0 15px 15px 21px;
    height: auto;

    &.no-charts{
        height: 100%;
    }
}

img {
    width: 240px;
    height: 360px;
}

.page {
    position: relative;
    padding-left: 0;
    background: none;
    box-shadow: none;
}

.footer {
    position: relative;
    bottom: 20px;
    width: 100%;
    max-height: 300px;
    display: flex;
    justify-content: space-between;
}

.cockpit {
    position: relative;
    width: 100%;
    margin-bottom: 120px;
}

.cockpit .center p {
    margin-bottom: 40px;
    font-size: 20px;
    color: $text-color;
    width: 50%;
    left: 50%;
    position: relative;
    transform: translateX(-50%);
}

.cockpit .center .btn {
    color: $sovis-white;
    padding: 10px 70px;
}

.cockpit .center .elipse {
    margin-bottom: 40px;
    > .big-svg-icons {
        width: 250px;
        height: 125px;
        margin-top: -10px;
    }
}
.no-charts .center{
    top: 50%;
    transform: translate(-50%, -50%);

    .elipse {
        margin-bottom: 20px;
    }
    .big-svg-icons {
        top: 45%;
    }
}

// Modal adicionar gráfico ao cockpit
.modal-card-body .subtitle {
    margin-bottom: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    font-size: 16px;
    color: $primary-color;
}

.manage-charts-link {
    font-size: 14px;
}

.manage-charts-shortcut {
    width: 100%;
    padding: 0 15px 10px 15px;
    display: flex;
    justify-content: flex-end;
}

.tag {
    background-color: $primary-color;
    color: $sovis-white;
}

.categorias .column {
    padding: 0.25rem 0.75rem;
    font-size: 14px;
}

.result-set {
    padding: 0.25rem 0.75rem;
    height: calc(100vh - 190px);
    overflow: auto;
}

.no-results {
    height: calc(100vh - 190px);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    color: $text-color;
}

.add-btn, .delete-btn {
    color: $sovis-white;
    text-align: center;
    padding: 10px;
    border: none;
    border-radius: 6px;
    @include gradient-button();
}

.delete-btn {
    @include exclude-button-2();
}

.chart-container {

    .chart{
        width: 32.5%;
        height: auto;
        min-height: 360px;
        &.big-number{
            height: 180px !important;
            min-height: unset !important;
        }
        &.speedometer {
            min-height: unset;
        }
        &.line-chart {
            width: 66%;
        }

        &.full-size-chart {
            width: 66% !important;
        }
    }
    .pkry-sizer {
        width: 32.5%;
    }
}

@media only screen and (max-width: 1200px) {
    .chart-container {
        .chart{
            width: 48.5% !important;
            height: auto !important;
            min-height: 360px !important;
            &.big-number{
                height: 180px !important;
                min-height: unset !important;
            }
            &.speedometer {
                min-height: unset !important;
            }
            &.line-chart {
                width: 100% !important;
            }

            &.full-size-chart {
                width: 66% !important;
            }
        }
        .pkry-sizer {
            width: 48.5%;
        }
    }
}

@media only screen and (max-width: 860px) {
    .footer {
        display: none;
    }

    .chart-container {

        .chart {
            width: 48.5% !important;
            height: auto !important;
            min-height: 360px !important;
            &.big-number{
                height: 180px !important;
                min-height: unset !important;
            }
            &.speedometer {
                min-height: unset !important;
            }
            &.line-chart {
                width: 100% !important;
            }

            &.full-size-chart {
                width: 66% !important;
            }
        }
        
        .pkry-sizer {
            width: 48.5%;
        }
    }
}

@media only screen and (max-width: 760px) {
    .footer {
        display: none;
    }
  
    .chart-container {

        .chart {
            width: 100% !important;
            height: auto !important;
            min-height: 360px !important;
            &.big-number{
                min-height: unset !important;
            }
            &.speedometer{
                height: 300px;
            }
            &.line-chart {
                width: 100% !important;
            }

            &.full-size-chart {
                width: 66% !important;
            }
        }
        .pkry-sizer {
            width: 100%;
        }
    }

    .result-set {
        height: calc(100vh - 305px);
    }  
}
</style>
